<template>
  <div class="flex flex-col items-center justify-center w-full h-full">
    <div v-if="stage === 'enter'" class="w-full">
      <h1 class="mb-6 text-5xl font-heading">{{ gameTitle }}</h1>
      <label for="id" class="block p-2 text-xl font-semibold font-main"
        >Race Number:</label
      >
      <input
        v-model.number="id"
        name="id"
        type="number"
        class="inline-block w-1/2 px-4 py-2 my-2 text-xl text-center bg-transparent border-2 border-green-400 rounded outline-none focus:border-green-700 dark:text-white"
        required
      />
      <h2
        v-if="error"
        class="mt-4 mb-2 text-2xl text-green-900 font-heading dark:text-white"
      >
        A Competitor with that Race Number Was Not Found. Please Try Again
      </h2>
      <h2
        v-if="alreadyRan"
        class="mt-4 mb-2 text-2xl text-green-900 font-heading dark:text-white"
      >
        Sorry You Have Already Ran
      </h2>
      <div>
        <button v-if="!loading" class="mt-6 button" @click="lookupCompetitor">
          Go
        </button>
        <button v-else class="mt-6 button">Loading</button>
      </div>
    </div>
    <div v-if="stage === 'confirm'" class="w-full">
      <h2 class="mb-6 text-5xl font-heading">
        Hello {{ competitor.name }}! [ {{ id }} ]
      </h2>
      <p class="text-2xl font-main">
        Is {{ competitor.name }} ({{ id }}) your name?
      </p>
      <div class="mt-10">
        <button class="button-secondary" @click="stage = 'enter'">Back</button>
        <button class="button" @click="proceed">
          Confirm and Start Game
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    gameId: {
      type: String,
      default: '',
    },
    gameTitle: {
      type: String,
      default: 'Hello!',
    },
    eventId: {
      type: String,
      default: '',
    },
    allowMultiRun: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      id: '',
      error: false,
      alreadyRan: false,
      loading: false,
      stage: 'enter',
      competitor: undefined,
    }
  },

  computed: {},

  methods: {
    lookupCompetitor: async function () {
      this.loading = true
      this.error = false
      this.alreadyRan = false

      this.competitor = await fetch(
        `/api/lookupCompetitor?raceNumber=${this.id}&game=${this.gameId}&eventId=${this.eventId}`
      ).then((response) => response.json())

      if (this.competitor.raceNumber !== this.id) this.error = true
      else if (this.competitor.started && !this.allowMultiRun)
        this.alreadyRan = true
      else if (this.competitor.success) this.stage = 'confirm'
      else this.error = true
      this.loading = false
    },

    proceed: function () {
      if (!this.competitor.name || !this.competitor.databaseId || !this.id)
        this.stage = 'enter'
      else
        this.$emit('competitorSelected', {
          raceNumber: this.id,
          name: this.competitor.name,
          databaseId: this.competitor.databaseId,
        })
    },
  },
}
</script>
